import i18n from '@/i18n';
import globalStore from '@/services/global.state';
import {http} from '@/utils/request';

export interface GenerateChatUrlParams {
  orderId?: string;
  type?: '1' | '2';
}

export interface QueryCustomerOrderParams {
  orderNo?: string;
  type?: '1' | '2';
}

const getCustomerServiceOrderId = (payload: any) => {
  return payload?.orderNo?.trim?.() || payload?.data?.orderNo?.trim?.() || '';
};

export async function postQueryCustomerOrder(
  params: QueryCustomerOrderParams = {},
) {
  const response = await http.post<QueryCustomerOrderParams, any>(
    'app/pay/customer/order/query',
    {
      orderNo: params.orderNo ?? '',
      type: params.type,
    },
  );

  return getCustomerServiceOrderId(response);
}

export function postGenerateChatUrl(params: GenerateChatUrlParams = {}) {
  const raw = i18n.language || globalStore.lang || 'en';
  const language = (raw.split(/[-_]/)[0] || 'en').toLowerCase();

  return http.post<
    GenerateChatUrlParams & {
      language: string;
    },
    string
  >('app/customerService/generateChatUrl', {
    language,
    orderId: params.orderId ?? '',
    type: params.type,
  });
}
